import { JwtTokenPayload } from "../types/apis";

export const parseJwt = (token: string): JwtTokenPayload => {
  if (!token) {
    throw Error("No JWT Token");
  }

  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  try {
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(""),
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    if (error instanceof Error) {
      throw Error("Error parsing JWT token: " + error.message);
    }
    throw Error("Error parsing JWT token");
  }
};
